'use strict';

(function () {
  function push(event, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    if (data) {
      for (var key in data) {
        if (data.hasOwnProperty(key)) payload[key] = data[key];
      }
    }
    window.dataLayer.push(payload);
  }

  // Vehicle Selected (confirmed)
  document.addEventListener('ymm:confirmed', function (e) {
    var v = e.detail && e.detail.vehicle;
    if (!v) return;
    push('fitment_vehicle_selected', {
      fitment_year: v.year,
      fitment_make: v.make,
      fitment_model: v.model,
      fitment_status: v.fitment ? v.fitment.status : '',
      fitment_sku: v.fitment ? v.fitment.sku : ''
    });
  });

  // Vehicle Cleared
  document.addEventListener('ymm:cleared', function () {
    push('fitment_vehicle_cleared');
  });

  // Custom Mount Flow Triggered
  function watchToolbox() {
    var cards = document.querySelectorAll('.fitment-mount-type__option');
    cards.forEach(function (card) {
      if (card.dataset.analyticsBound) return;
      card.dataset.analyticsBound = 'true';
      card.addEventListener('click', function () {
        if (card.dataset.mountValue === 'Custom Mount') {
          push('fitment_toolbox_triggered');
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', watchToolbox);
  document.addEventListener('quick-view:open', function () { setTimeout(watchToolbox, 60); });

  // Compatible Product Viewed (click from filtered collection)
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var grid = link.closest('[data-fitment-collection]');
    if (!grid) return;
    var href = link.getAttribute('href');
    var match = href.match(/\/products\/([^/?#]+)/);
    if (match) {
      push('fitment_compatible_product_viewed', { product_handle: match[1] });
    }
  });

})();
